export default __webpack_public_path__ + "static/freezer-hand-0cfd76c792813063ec10ca3d5a06f9b9.jpg";